import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {EcpUiLibComponent} from './ecp-ui-lib.component';
import {BreadCrumbComponent} from './bread-crumb/bread-crumb.component';
import {FlexLeftCenterRightComponent} from './layout/flex-lcr-module/flex-left-center-right/flex-left-center-right.component';
import {FlexTopCenterBottomComponent} from './layout/flex-tcb-module/flex-top-center-bottom/flex-top-center-bottom.component';
import {FlexBottomComponent} from './layout/flex-tcb-module/flex-bottom/flex-bottom.component';
import {FlexTopComponent} from './layout/flex-tcb-module/flex-top/flex-top.component';
import {FlexBodyComponent} from './layout/flex-tcb-module/flex-body/flex-body.component';
import {FlexLeftComponent} from './layout/flex-lcr-module/flex-left/flex-left.component';
import {FlexRightComponent} from './layout/flex-lcr-module/flex-right/flex-right.component';
import {ModuleTitleComponent} from './layout/flex-tcb-module/module-title/module-title.component';
import {ModuleBottomComponent} from './layout/flex-tcb-module/module-bottom/module-bottom.component';
import {LayoutVerticalCenterComponent} from './layout/layout-vertical-center/layout-vertical-center.component';
import {CopyrightComponent} from './copyright/copyright.component';
import {CardInfoComponent} from './card-info/card-info.component';
import {DocsComponentRecommendComponent} from './docs-component-recommend/docs-component-recommend.component';
import {NavBarComponent} from './nav-bar/nav-bar.component';
import {MapSwitchComponent} from './map-switch/map-switch.component';
import {MapDotPopupComponent} from './map-dot-popup/map-dot-popup.component';
import {LegendComponent} from './legend/legend.component';
import {UploadFileComponent} from './upload-file/upload-file.component';
import {TopNavComponent} from './nav-module/top-nav/top-nav.component';
import {AlarmComponent} from './nav-module/alarm/alarm.component';
import {DropDownMenuComponent} from './nav-module/drop-down-menu/drop-down-menu.component';
import {ToolBar3Component} from './tool-bar3/tool-bar3.component';
import {EcpLoginformComponent} from './ecp-login-moudle/ecp-loginform/ecp-loginform.component';
import {StatusBarComponent} from './status-bar/status-bar.component';
import {TabsComponent} from './tabs-module/tabs/tabs.component';
import {UserInfoComponent} from './nav-module/user-info/user-info.component';
import {PageLeftNavComponent} from './page-left-nav/page-left-nav.component';
import {EcpOpenTagsComponent} from './ecp-tags-model/ecp-open-tags/ecp-open-tags.component';
import {EcpOpenTagComponent} from './ecp-tags-model/ecp-open-tag/ecp-open-tag.component';
import {SidebarTipInfoComponent} from './popup-sidebar-module/sidebar-tip-info/sidebar-tip-info.component';
import {UserInfoListComponent} from './nav-module/user-info-list/user-info-list.component';
import {SeachModuleComponent} from './seach-module/seach-module.component';
import {HttpStatusPageComponent} from './httpPage/http-status-page/http-status-page.component';
import {EcpTemplateComponent} from './ecp-template/ecp-template.component';
import {CollapseListComponent} from './popup-sidebar-module/collapse-list/collapse-list.component';
import {ListComponent} from './dataTable-module/list/list.component';
import {TabComponent} from './tabs-module/tab/tab.component';
import {SidebarBtnLinkComponent} from './popup-sidebar-module/sidebar-btn-link/sidebar-btn-link.component';
import {ToolBarComponent} from './tool-bar/tool-bar.component';
import {EcpLoginPageComponent} from './ecp-login-moudle/ecp-login-page/ecp-login-page.component';
import {SelectMapTypeComponent} from './select-map-type/select-map-type.component';
import {ToolBar2Component} from './tool-bar2/tool-bar2.component';
import {RippleComponent} from './animation/ripple/ripple.component';

@NgModule({
    declarations: [
        EcpUiLibComponent,
        /**/
        BreadCrumbComponent,
        FlexTopCenterBottomComponent,
        FlexLeftCenterRightComponent,
        FlexTopComponent,
        FlexBottomComponent,
        FlexBodyComponent,
        FlexLeftComponent,
        FlexRightComponent,
        /**/
        ModuleTitleComponent,
        ModuleBottomComponent,
        LayoutVerticalCenterComponent,
        /**/
        CopyrightComponent,
        CardInfoComponent,
        DocsComponentRecommendComponent,
        NavBarComponent,
        MapSwitchComponent,
        MapDotPopupComponent,
        LegendComponent,
        UploadFileComponent,
        /*é¡¶é¨å¯¼èª*/
        TopNavComponent,
        AlarmComponent,
        DropDownMenuComponent,
        UserInfoComponent,
        UserInfoListComponent,
        /**/
        ListComponent,
        SeachModuleComponent,
        HttpStatusPageComponent,
        /**/
        StatusBarComponent,
        SelectMapTypeComponent,
        TabsComponent,
        TabComponent,
        PageLeftNavComponent,

        ToolBarComponent,
        ToolBar2Component,
        EcpOpenTagsComponent,
        EcpOpenTagComponent,
        ToolBar3Component,
        EcpTemplateComponent,
        SidebarTipInfoComponent,
        SidebarBtnLinkComponent,
        CollapseListComponent,
        RippleComponent,
        /*ç»å½*/
        EcpLoginformComponent,
        EcpLoginPageComponent],
    imports: [CommonModule, BrowserAnimationsModule],
    exports: [EcpUiLibComponent,
        BreadCrumbComponent,
        FlexTopCenterBottomComponent,
        FlexLeftCenterRightComponent,
        FlexTopComponent,
        FlexBottomComponent,
        FlexBodyComponent,
        FlexLeftComponent,
        FlexRightComponent,
        /**/
        ModuleTitleComponent,
        ModuleBottomComponent,
        LayoutVerticalCenterComponent,
        /**/
        CopyrightComponent,
        CardInfoComponent,
        DocsComponentRecommendComponent,
        NavBarComponent, MapSwitchComponent, MapDotPopupComponent, LegendComponent,
        UploadFileComponent,
        /*é¡¶é¨å¯¼èª*/
        TopNavComponent,
        AlarmComponent,
        DropDownMenuComponent,
        UserInfoComponent,
        UserInfoListComponent,
        /**/
        ListComponent,
        SeachModuleComponent,
        HttpStatusPageComponent,
        /**/
        StatusBarComponent, SelectMapTypeComponent, TabsComponent, TabComponent, PageLeftNavComponent,

        ToolBarComponent, ToolBar2Component, EcpOpenTagsComponent,
        EcpOpenTagComponent, ToolBar3Component,
        EcpTemplateComponent, SidebarTipInfoComponent,
        SidebarBtnLinkComponent, CollapseListComponent,
        RippleComponent,
        /*ç»å½*/
        EcpLoginformComponent,
        EcpLoginPageComponent]
})
export class EcpUiLibModule {
}
